import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_AUTH } from '../constants/http-context.tokens';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  get<T>(endpoint: string, params?: Record<string, string | number | boolean>, context?: HttpContext): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, value.toString());
        }
      });
    }
    return this.http.get<T>(url, { params: httpParams, ...(context ? { context } : {}) });
  }

  getById<T>(endpoint: string, id: string | number): Observable<T> {
    const url = `${this.baseUrl}${endpoint}/${id}`;
    return this.http.get<T>(url);
  }

  post<T>(endpoint: string, body: any, skipAuth = false): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    if (skipAuth) {
      return this.http.post<T>(url, body, { context: new HttpContext().set(SKIP_AUTH, true) });
    }
    return this.http.post<T>(url, body);
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.put<T>(url, body);
  }

  delete<T>(endpoint: string): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.delete<T>(url);
  }

  postFile<T>(endpoint: string, formData: FormData): Observable<T> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.post<T>(url, formData);
  }
   getBlobWithResponse(endpoint: string, params?: any): Observable<HttpResponse<Blob>> {
    const url = `${this.baseUrl}${endpoint}`;
    return this.http.get(url, { 
      params, 
      responseType: 'blob',
      observe: 'response'
    });
  }

}
